import { APP_INITIALIZER } from '@angular/core';
import { AuthService } from './authentication/auth.service';
import { StartupService } from './bootstrap/startup.service';
import { TranslateLangService } from './bootstrap/translate-lang.service';

export function TranslateLangServiceFactory(translateLangService: TranslateLangService) {
  return () => translateLangService.load();
}
export function StartupServiceFactory(startupService: StartupService) {
  return () => startupService.load();
}
export function AuthServiceFactory(authService: AuthService) {
  return () => authService;
}

export const appInitializerProviders = [
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService, TranslateLangService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: AuthServiceFactory,
    deps: [AuthService],
    multi: true,
  },
];
